<app-header></app-header>

<app-right-side></app-right-side>
<div *ngIf="isLoaderVisible" class="preloader js-preloader">
    <img  src="assets/img/loader.webp">
</div>
<div class="container" >
    <div class="row">
        <div class="col col-xl-2 col-lg-6 col-md-6 col-sm-6 col-6">&nbsp;</div>
        <div class="col col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12" style="top:0px">
            <div class="ui-block responsive-flex" style="background-color: #fff; color: var(--text-color);">
                <div class="ui-block-title" style="text-align:center; margin: 0px auto;">
                    <img src="assets/img/voting/voting-award-message.webp" style="height: auto; width: 75%; position: relative; margin: 0px auto;" class="img-responsive img-fluid" alt="banner">
                    <div *ngIf="currentUser.success.user.id == 1 || currentUser.success.user.id == 5 || currentUser.success.user.id == 18 || currentUser.success.user.user_type_id == '1'">
                        <a routerLink="/add-voting-questions">
                            <img src="assets/img/dashboard.webp" class="img-responsive img-fluid center" alt="Dashboard" style="width: 6rem;"></a>
                    </div>
                </div>
            </div>
          
        </div>
        <div class="col col-xl-2 col-lg-6 col-md-6 col-sm-6 col-6">&nbsp;</div>
    </div>
</div>




<div *ngIf="annualVisible" class="container">

    <div class="row" >
        <div class="col col-xl-3 col-lg-6 col-md-6 col-sm-6 col-6">&nbsp;</div>
        <div class="col col-xl-3 col-lg-6 col-md-6 col-sm-6 col-6" style="top:0px">

            <div (click)="onClick('annualQuestion')">
                <img src="assets/img/annualQuestion.webp" class="img-responsive card-img" style="width: 100%; height: auto;">
            </div>


        </div>
        <div class="col col-xl-3 col-lg-6 col-md-6 col-sm-6 col-6" style="top:0px">
            <div (click)="onClick('eventQuestion')">
                <img src="assets/img/eventQuestion.webp" class="img-responsive card-img" style="width: 100%; height: auto;">
            </div>
        </div>
        <div class="col col-xl-3 col-lg-6 col-md-6 col-sm-6 col-6">&nbsp;</div>
    </div>


</div>

<section *ngIf="!annualVisible" id="tabs" class="project-tab">
    <div class="container">
        <div class="row">
            <div class="col-md-12" style="top:0px">
                <nav>
                    <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                        <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true" style="background-color: #336699; color:#fff;">Stage 1 &nbsp;<i class="fad fa-long-arrow-alt-right"></i></a>
                        <a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false" style="background-color: #a34428; color:#fff;">Stage 2 &nbsp;<i class="fad fa-long-arrow-alt-right"></i></a>
                        <a class="nav-item nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false"style="background-color: #317431; color:#fff;">Stage 3</a>
                    </div>
                </nav>
                <div *ngIf="questions.length === 0" class="ui-block-title">
                    <h6 class="display-message">No Question Found!
                    </h6>
                </div>
                <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                        <br>
                        <form [formGroup]="votingForm" (ngSubmit)="castVote()" >
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <div class="row">
                                <div *ngFor="let question of questions;let i=index" class="col-lg-4 col-xl-4 col-md-6 col-sm-12 col-12">
                                        <div style="border:1px solid var(--text-color); padding: 10px; border-radius: 20px; background-color: var(--backgroundpost-color);">
                                            <label class="control-la1bel custom-labl1e" style="font-size: 15px; width: 100%; height: 40px; background-color: var(--backgroundpost-color); color: var(--text-color); font-weight: 600;">{{i+1}}. {{question.question}} </label>
                                            <ng-autocomplete [data]="players" placeHolder="Please Select your Answer" [searchKeyword]="keyword" formControlName="answer" (selected)='selectEvent($event, i, question)' (inputChanged)='onChangeSearch($event)' (inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate"
                                                [notFoundTemplate]="notFoundTemplate">
                                            </ng-autocomplete>

                                            <ng-template #itemTemplate let-player>
                                                <a style="font-size:12px;font-weight: bold; background-color: var(--background-color); color: var(--text-color);" [innerHTML]="player.fullName"></a>
                                            </ng-template>

                                            <ng-template #notFoundTemplate let-notFound>
                                                <div style="font-size:12px;font-weight: bold; background-color: var(--background-color); color: var(--text-color);" [innerHTML]="notFound"></div>
                                            </ng-template>
                                        </div>
                                        <br>
                                    </div>
                                </div></div>
                            <div class="alert alert-info text-center note" role="alert" style="font-size: 15px;">
                                Note: All Questions are mandatory. Please answer all the Question
                            </div>
                            <div style="text-align: center;">
                            <button [disabled]="votingForm.invalid" class="btn" style="background-color: #336699; color:#fff; text-align: center; font-size: 15px;">
                                <i class="fad fa-paper-plane"></i>&nbsp;Submit Stage 1
                            </button></div>
                        </form>

                    </div>
                    <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                        <br><br><br>
                        <h1 class="text-center" style="font-weight: bold;"> Stage 2 Question coming soon </h1>
                    </div>
                    <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                        <br><br><br>
                        <h1 class="text-center" style="font-weight: bold;"> Stage 3 Question coming soon </h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>